import Icon from '@components/v2/ui/Icon/Icon';
import LabeledChip from '@components/v2/ui/LabeledChip/LabeledChip';
import { LabeledChipAppearance } from '@components/v2/ui/LabeledChip/labeledChip.styles';
import { RotateCw } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import useGetSelloutMessage from '../../../modules/sellout/hooks/useGetSelloutMessage';
import { useTranslation } from '../../../modules/translation/TranslationContext';

interface SelloutProductTagProps {
  quantity: number;
  useSuffix?: boolean;
  variant?: LabeledChipAppearance;
  className?: string;
}

const SelloutProductTag = ({
  quantity,
  useSuffix = false,
  variant,
  className,
}: SelloutProductTagProps) => {
  const { translate } = useTranslation();
  const { getSelloutMessage } = useGetSelloutMessage();

  const message = getSelloutMessage(quantity);
  const label = useSuffix
    ? translate(LangEnum.GLOBAL_SOLD_FEMALE_PLURAL, { quantity })
    : `${quantity}`;

  return (
    <LabeledChip
      content={label}
      appearance={variant}
      tooltip={message}
      title={message}
      className={className}
      icon={<Icon icon={RotateCw} size="xs" />}
    />
  );
};

export default SelloutProductTag;
